import { Subscription } from 'rxjs';
import { forEach } from 'lodash-es';
import { FormGroup, AbstractControl } from '@angular/forms';

/**
 *
 */
export function trackById(index: number, obj: { [key: string]: any }): string {
  return obj?.id;
}

/**
 *
 */
export function trackByIndex(index: number, obj: { [key: string]: any }): number {
  return index;
}

/**
 *
 */
export function clearSubscription(key: string, dictionary: Dictionary<Subscription>): void {
  const subscription = dictionary[key];
  if (subscription) {
    subscription.unsubscribe();
  }
  delete dictionary[key];
}

/**
 *
 */
export function clearSubscriptions(dictionary: Dictionary<Subscription>): void {
  forEach(Object
    .keys(dictionary), (key) => clearSubscription(key, dictionary));
}

/**
 *
 */
export function validVariant(form: FormGroup, field: string): string {
  const control: AbstractControl = form?.get(field);
  return control?.pristine
    ? ''
    : control.valid
      ? ''
      : 'warn';
}
